import React from 'react';
import styled from 'styled-components';
import Spacer from 'features/shared/Spacer';
import { BlueButton } from 'features/shared/ui/Button';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 12px 12px 16px;
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
  background: rgba(9, 21, 38, 0.07);
  border-radius: 10px;
`;

interface Props {
  title: string;
  onClick: () => void;
}

const Component = ({ children, title, onClick }: React.PropsWithChildren<Props>) => {
  return (
    <Container>
      {children}
      <Spacer />
      <BlueButton onClick={onClick}>{title}</BlueButton>
    </Container>
  );
};

export default Component;
